{
  "name": "dths",
  "version": "0.0.1",
  "author": {
    "name": "Molaris Kft.",
    "email": "hello@molaris.dev"
  },
  "engines": {
    "node": "^22.11",
    "pnpm": ">=10"
  },
  "description": "dths",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint",
    "build:docker": "ng build --configuration=docker",
    "generate-api": "npx openapi-generator-cli generate -g typescript-angular -i http://localhost:8080/v3/api-docs -o ./src/app/core/api",
    "compodoc": "npx compodoc -p tsconfig.doc.json",
    "clean": "ng cache clean",
    "dev": "ng serve --configuration=dev",
    "local": "ng serve --configuration=local",
    "docker": "ng serve --configuration=docker"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.12",
    "@angular/cdk": "^21.2.10",
    "@angular/common": "^21.2.12",
    "@angular/compiler": "^21.2.12",
    "@angular/core": "^21.2.12",
    "@angular/forms": "^21.2.12",
    "@angular/localize": "^21.2.11",
    "@angular/material": "^21.2.10",
    "@angular/material-moment-adapter": "^21.2.10",
    "@angular/platform-browser": "^21.2.12",
    "@angular/platform-browser-dynamic": "^21.2.12",
    "@angular/router": "^21.2.12",
    "@danielmoncada/angular-datetime-picker": "^21.0.0",
    "@ngx-loading-bar/core": "^7.0.1",
    "@ngx-loading-bar/router": "^7.0.1",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "angular-auth-oidc-client": "^21.0.2",
    "angular-feather": "^6.5.1",
    "angularx-qrcode": "^21.0.5",
    "apexcharts": "~5.10.6",
    "bootstrap": "^5.3.8",
    "chart.js": "^4.5.1",
    "cookieconsent": "^3.1.1",
    "dap-design-system": "^0.55.4",
    "jwt-decode": "^4.0.0",
    "material-symbols": "^0.44.5",
    "moment": "^2.30.1",
    "ng-apexcharts": "~2.4.0",
    "ngx-cookieconsent": "^8.0.0",
    "ngx-mask": "^21.0.1",
    "ngx-mat-multi-sort": "^21.0.2",
    "ngx-scrollbar": "^19.1.5",
    "rxjs": "~7.8.2",
    "subsink": "^1.0.2",
    "tslib": "^2.8.1",
    "xlsx": "^0.18.5",
    "zone.js": "~0.16.2"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^21.3.1",
    "@angular-eslint/eslint-plugin": "^21.3.1",
    "@angular-eslint/eslint-plugin-template": "^21.3.1",
    "@angular-eslint/schematics": "^21.3.1",
    "@angular-eslint/template-parser": "^21.3.1",
    "@angular/build": "^21.2.9",
    "@angular/cli": "~21.2.10",
    "@angular/compiler-cli": "^21.2.12",
    "@openapitools/openapi-generator-cli": "^2.32.0",
    "@types/jasmine": "~6.0.0",
    "@typescript-eslint/eslint-plugin": "^8.59.2",
    "@typescript-eslint/parser": "^8.59.2",
    "eslint": "^10.3.0",
    "jasmine-core": "~6.2.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.2.0",
    "typescript": "~6.0.3"
  }
}